import { useEffect } from 'react';

/**
 * Custom hook to dynamically set the page title
 * @param {string} title - The page title (without the site name suffix)
 * @param {string} siteName - Optional site name suffix (defaults to "Remote Job")
 *
 * @example
 * // Basic usage
 * usePageTitle("Jobs Listing");
 * // Result: "Jobs Listing | Remote Job"
 *
 * @example
 * // Dynamic title based on data
 * usePageTitle(job ? `${job.title} at ${company.name}` : "Loading...");
 * // Result: "Senior Developer at Google | Remote Job"
 */
const usePageTitle = (title, siteName = 'Remote Job') => {
  useEffect(() => {
    if (title) {
      // Set the document title with site name suffix
      const fullTitle = `${title} | ${siteName}`;
      document.title = fullTitle;
    }

    // Cleanup: restore default title when component unmounts
    return () => {
      document.title = 'Remote Job - Find Your Dream Remote Job';
    };
  }, [title, siteName]);
};

export default usePageTitle;
